import type {MembershipSubscription} from '@/app/modules/membership/api'

/**
 * Memberships the user can switch to: not disabled and not expired. `is_enabled: null` means Susy
 * could not be asked, which the backend already treats as usable. Blocked and revoked memberships
 * never reach the web (`GET /v1/user/subscriptions` drops them).
 */
export const getUsableMemberships = (
  subscriptions: MembershipSubscription[]
): MembershipSubscription[] =>
  subscriptions.filter((s) => s.is_enabled !== false && !s.is_expired)

/**
 * The membership to activate for a user who has none active yet (no billing row), e.g. a web-only
 * user added to a key by hand or before ever linking it. Only an unambiguous choice is made for
 * them; with several usable memberships the user picks one in Settings.
 */
export const pickMembershipToActivate = (
  subscriptions: MembershipSubscription[]
): MembershipSubscription | null => {
  const usable = getUsableMemberships(subscriptions)
  return usable.length === 1 ? usable[0] : null
}
